import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { PRINCIPAL_STATES_OPTIONS, PRINCIPAL_STATES } from '../../../constants';

const PrincipalStateFilter = ({ withoutDeleted }) => {
  const filteredOptions = useMemo(
    () =>
      !withoutDeleted
        ? PRINCIPAL_STATES_OPTIONS
        : PRINCIPAL_STATES_OPTIONS.filter(o => o.value !== PRINCIPAL_STATES.DELETED),
    [withoutDeleted]
  );

  return (
    <IconFilter
      multiple
      name="activeStates"
      position="bottom right"
      placement="bottom-end"
      as={FilterSelectComponent}
      options={filteredOptions}
    />
  );
};

PrincipalStateFilter.propTypes = { withoutDeleted: PropTypes.bool };
PrincipalStateFilter.defaultProps = { withoutDeleted: false };

export default PrincipalStateFilter;
